import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import { getApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// App Check attests that Firebase requests come from a browser running
// our registered origin (cybercore.space etc.). Storage rules for
// bundles/public/{fileName} require a valid App Check token, so anon
// site visitors can fetch the public bundle without signing in, but
// other origins / scripts cannot.
//
// Enforcement is per-rule (via `request.app != null`), not product-wide,
// so existing Foundry/auth flows keep working unchanged.
export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig();
	const siteKey = (config.public as any)?.recaptchaSiteKey as string | undefined;

	if (!siteKey) {
		console.warn('[app-check] recaptchaSiteKey not configured — skipping App Check init');
		return;
	}

	// Debug token on localhost so dev doesn't need a real reCAPTCHA flow.
	// Copy the token the SDK prints to console into the Firebase console
	// under App Check → Apps → manage debug tokens.
	if (import.meta.dev) {
		(globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = "e265c4ff-ef57-4af3-ad4d-43d752f2eca8";
	}

	try {
		initializeAppCheck(getApp(), {
			provider: new ReCaptchaEnterpriseProvider(siteKey),
			isTokenAutoRefreshEnabled: true,
		});
	} catch (err) {
		console.error('[app-check] init failed:', err);
	}
});
